import { render, staticRenderFns } from "./medicineRecord.vue?vue&type=template&id=b696aaf4&scoped=true&"
import script from "./medicineRecord.vue?vue&type=script&lang=js&"
export * from "./medicineRecord.vue?vue&type=script&lang=js&"
import style0 from "./medicineRecord.vue?vue&type=style&index=0&id=b696aaf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b696aaf4",
  null
  
)

export default component.exports